import styled, { Modal, Tab, Icon } from "grabcad-ui-elements";

export const SSOContainer = styled.div`
    width: 800px;
    display: grid;
`;
export const SSOWrapper = styled.div`
    width: 800px;
    margin-top: 10px;
`;

export const HeadingContainer = styled.div`
    display: flex;
    align-items: center; /* Aligns the content in the center vertically */
    justify-content: flex-start; /* Aligns the items to the left */
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: 2px;
    border: 1px solid #d6d6d6;
`;

export const ColumnA = styled.div`
    width: 60%;
    padding: 20px;
    height: 350px;
    background-color: ${(props) => props.color || "#F5F5F5"};
`;

export const ColumnB = styled.div`
    width: 40%;
    padding: 20px;
    height: 350px;
    background-color: ${(props) => props.color || "#F5F5F5"};
`;

export const InlineTable = styled.table`
    border-collapse: collapse;
    margin-top: 1rem;
`;

export const InlineTableCell = styled.td`
    vertical-align: top;
    padding-top: 0.3rem;
    padding-right: 0.5rem;
    padding-bottom: 1.5rem;
`;

export const Banner = styled.div`
    background: #ebeff7;
    border: 1px solid #003393;
    padding: 10px;
    border-radius: 5px;
    width: 800px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between; /* Pushes button to the right */
    align-items: center; /* Aligns text and button vertically */
`;

export const BannerContent = styled.div`
    display: flex;
    align-items: center; /* Aligns icon and text on the same line */
    gap: 10px; /* Adds space between icon and text */
`;

export const StyledTab = styled(Tab)`
    width: 800px;
`;

export const paneStyle = { paddingTop: "40px" };

export const RadioGroupContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
`;

export const RadioContainer = styled.div`
    display: flex;
    align-items: center;
    margin-right: 20px;
`;

export const InputContainer = styled.div`
    width: 100%;
`;

export const ErrorMessage = styled.div`
    color: red;
`;

export const FileInput = styled.input`
    display: none;
    text-overflow: ellipsis !important;
`;

export const FileLabel = styled.label`
    cursor: pointer;
    background-color: #ffffff;
    color: #006ec2 !important;
    padding: 10px;
    border-radius: 5px;
    text-overflow: ellipsis !important;
    display: inline-flex;
    align-items: center;
    border: 1px solid #d6d6d6;
    text-align: center;
    justify-content: center;
    margin-top: 10px;

    &:hover {
        background-color: #ffffff;
    }
`;

export const ModalContainer = styled.div`
    width: 100%;
    max-width: 500px;
    height: auto;
    padding: 1.5rem 2rem;
    background: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 1rem;
        gap: 1rem;
    }

    @media (max-width: 480px) {
        padding: 0.75rem;
        border-radius: 6px;
        gap: 0.75rem;
    }
`;

export const SSOModal = styled(Modal)`
    width: 100%;
    max-width: 500px !important;
    height: auto;
    max-height: 90vh; /* prevent overflow on small screens */
    overflow-y: auto; /* enable scroll when content exceeds height */
`;

export const IconPlaceholder = styled.div`
    width: 48px;
    height: 48px;
    position: relative;
`;

export const Message = styled.div`
    align-self: stretch;
    text-align: left;
    color: #333333;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;
`;

export const ButtonGroup = styled.div`
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;
`;

export const SecondaryButton = styled.div`
    padding: 6px 6px;
    border-radius: 4px;
    outline: 1px solid #700ac1;
    outline-offset: -1px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const SecondaryText = styled.div`
    padding: 4px 8px 4px 6px;
    color: #700ac1;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    text-transform: capitalize;
    line-height: 16px;
    letter-spacing: 1.25px;
`;

export const PrimaryButton = styled.div`
    padding: 6px 6px;
    border-radius: 4px;
    background: #700ac1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const PrimaryText = styled.div`
    padding: 4px 8px 4px 6px;
    color: white;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    text-transform: capitalize;
    line-height: 16px;
    letter-spacing: 1.25px;
    text-align: center;
`;

export const StyledLabelWrapper = styled.div`
    display: inline-flex;
    align-items: baseline;
    margin-bottom: 5px;
`;

export const StyledLabel = styled.label`
    font-weight: 600;
    display: inline-block;
    &::after {
        content: "*";
        color: red;
        font-size: 1.2em;
        margin-left: 4px;
    }
`;

export const StyledSup = styled.sup`
    display: inline-block;
    margin-left: 2px;
`;

export const StyledInfoIcon = styled(Icon)`
    cursor: pointer;
    margin-top: 8px;
`;

export const VersionInfoContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    background: #fff;
    padding: 10px 14px;
    border-radius: 6px;
    font-family: "Roboto", sans-serif;
    color: #333333;
    font-size: 14px;
    line-height: 20px;
    flex-wrap: wrap; /* allows wrapping on smaller screens */
`;
export const VersionText = styled.span`
    display: inline;
`;
